import IUserGet from 'api/interfaces/users/IUserGet';

/**
 * The user has the permission for some target, e.g. write_offers for any department.
 * Without the write permission the user can only read (read_offers etc.).
 */
const hasPermissionType = (
  currentUser: IUserGet | null | undefined,
  permissionType: string
): boolean =>
  currentUser?.permissions?.some(
    (permission) => permission.type === permissionType
  ) ?? false;

export default hasPermissionType;
